import { makeStyles } from '@material-ui/core'
import actions from 'actions'
import GrinFloatingPopup from 'components/common/menu/GrinFloatingPopup'
import { NotifyPracticeReasons, humanSelectableNotifyPracticeReasons } from 'consts/giConsts'
import React, { useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { trackEvent } from 'utils/analyticsUtils'
import NotifyPracticeForm from '../NotifyPractice/NotifyPracticeForm'

const useStyles = makeStyles(theme => ({
  title: {
    fontWeight: 'bold'
  },
  floatingPopup: {
    width: 374
  }
}))

const NotifyPracticeFloatingPopup = ({
  triggerComponent,
  children,
  onOpen,
  onClose,
  isOpen,
  patientId,
  practiceName
}) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const dispatch = useDispatch()

  const [reason, setReason] = useState(NotifyPracticeReasons.Clinical)
  const [selectedPracticeMembers, setSelectedPracticeMembers] = useState([])
  const [note, setNote] = useState('')

  const isSubmitButtonDisabled = useMemo(
    () => reason === NotifyPracticeReasons.SpecificMembersAttention && !selectedPracticeMembers.length,
    [reason, selectedPracticeMembers]
  )

  const handleCloseMenu = useCallback(() => {
    onClose()
    setSelectedPracticeMembers([])
    trackEvent('Notify Practice - menu closed', {
      origin: 'Patients header',
      patientId,
      practiceName
    })
  }, [onClose, patientId, practiceName])

  const handleSubmit = useCallback(() => {
    const selectedPracticeMembersIds = selectedPracticeMembers.map(memberOption => memberOption.value)

    trackEvent('Notify Practice - submit info', {
      reason,
      patientId,
      source: 'popup',
      practiceName,
      selectedPracticeMembersIds,
      withNote: !!note,
      noteLength: note?.length
    })
    dispatch(
      actions.hiNotifyPractice({
        patientId,
        reason,
        note,
        selectedPracticeMembersIds
      })
    )
    setReason(NotifyPracticeReasons.Clinical)
    setSelectedPracticeMembers([])
    setNote('')
    onClose()
  }, [reason, patientId, practiceName, selectedPracticeMembers, note, dispatch, onClose])

  return (
    <GrinFloatingPopup
      className={classes.floatingPopup}
      title={t('dialogs.notifyPractice.title')}
      titleClassName={classes.title}
      triggerComponent={triggerComponent}
      secondaryBtnLabel={t('general.cancel')}
      primaryBtnLabel={t('general.confirm')}
      buttonProps={{
        width: 128,
        height: 36
      }}
      onPrimaryBtnClick={handleSubmit}
      isPrimaryBtnDisabled={isSubmitButtonDisabled}
      onSecondaryBtnClick={handleCloseMenu}
      open={isOpen}
      onOpen={onOpen}
      onClose={handleCloseMenu}
    >
      <NotifyPracticeForm
        reason={reason}
        note={note}
        reasons={humanSelectableNotifyPracticeReasons}
        onChangeReason={setReason}
        onChangeNote={setNote}
        selectMemberInputFullWidth
        selectedPracticeMembers={selectedPracticeMembers}
        setSelectedPracticeMembers={setSelectedPracticeMembers}
      />
    </GrinFloatingPopup>
  )
}

export default NotifyPracticeFloatingPopup
